import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';
import {PhoneMaskModel} from './models/phone-mask';

@Pipe({
  name: 'formatPhone'
})
export class FormatPhonePipe implements PipeTransform {

  // https://medium.com/@Pierre_anthill/angular-2-4-pretty-phone-number-pipe-2da3fab8fe6e

  transform(phoneValue: any, country?: any): any {
    try {
      if (country == null) {
        country = 'US';
      }

      const phoneNumber = parsePhoneNumber(phoneValue + '', country as CountryCode);

      return phoneNumber.formatNational();
    } catch (error) {
      return phoneValue;
    }
  }

}


@Pipe({
  name: 'fancyPhone'
})
export class FancyPhonePipe {
  transform(rawNum: any) {

    try {
      rawNum = rawNum.charAt(0) !== 0 ? '0' + rawNum : '' + rawNum;

      let newStr = '';
      let i = 0;

      for (; i < Math.floor(rawNum.length / 2) - 1; i++) {
        newStr = newStr + rawNum.substr(i * 2, 2) + '-';
      }

      return newStr + rawNum.substr(i * 2);
    } catch (error) {
      return rawNum;
    }

  }
}

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {

  transform(phoneValue: string): string {
    try {
      phoneValue = phoneValue.replace(/\D/g, '').padStart(10,"-");

      //const phoneMaskArr: PhoneMaskModel[] = [];
      const phoneMaskStr = '(___) ___-____';
      let formatedPhone: string = '';

      let maskInc: number = 0;
      let phoneInc: number = 0;
      const phoneLen: number = phoneValue.length;

      while (maskInc < phoneMaskStr.length) {
        const pChar = phoneMaskStr.substr(maskInc, 1);
        if (pChar == '_' && phoneInc < phoneLen) {
          formatedPhone += phoneValue.substr(phoneInc, 1);
          phoneInc++;
        } else {
          formatedPhone += pChar;
        }
        maskInc++;
      }

      return formatedPhone;
/*
      if (phoneValue.length < 10) {
        const phonePadding = '          ';
        phoneValue += phonePadding.substr(phoneValue.length);
      }

let pChar = phoneMaskStr.substr(inc, 1);
        if (pChar != ' ') {
          let pItem: PhoneMaskModel = new PhoneMaskModel();
          pItem.position = inc;
          pItem.symbol = pChar;
          phoneMaskArr.push(pItem);
        }
*/


    } catch (error) {
      return phoneValue;
    }
  }

}
